import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTabletCheck = () => {
  return (
    <g>
      <path d="m4.9468 8.5571 1.665 1.665a.75.75 0 0 0 1.0605 0l3.3809-3.3809a.75.75 0 1 0 -1.0605-1.0604l-2.8506 2.8505-1.1348-1.1347a.75.75 0 0 0 -1.0605 1.0605z" />
      <path d="m13.1772.0405h-10.3544a1.7021 1.7021 0 0 0 -1.7 1.7v12.5188a1.7021 1.7021 0 0 0 1.7 1.7h10.3544a1.7021 1.7021 0 0 0 1.7-1.7v-12.5186a1.7021 1.7021 0 0 0 -1.7-1.7002zm-10.3545 1.4h10.3545a.3.3 0 0 1 .3.3v1.0666h-10.9543v-1.0664a.3.3 0 0 1 .2999-.2998zm10.6544 2.767v7.5859h-10.9542v-7.5859zm-.3 10.3516h-10.3543a.3.3 0 0 1 -.3-.3v-1.0653h10.9543v1.0654a.3.3 0 0 1 -.2999.2999z" />
    </g>
  );
};

export default withIcon(IconTabletCheck);
